// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNote = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M18 4H5v15h4v2H3V2h17v6h-2z" />,
    <path d="M7 8h9V6H7zm9 4H7v-2h9zm-4 4H7v-2h5z" />,
    <path
      fillRule="evenodd"
      d="M19.208 10.137l4.244 4.244-8.317 8.726h-4.271v-4.215zm1.449 4.277L19.243 13l-6.379 6.692v1.415h1.414z"
    />
  );
export default SvgIconNote;
